function safeFilename(name) {
  return (
    (name || 'docente')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ _-]+/g, '')
      .trim()
      .replace(/\s+/g, '_')
      .slice(0, 80) || 'docente'
  )
}

const COLUMNS = ['Día', 'Horario', 'Asignatura', 'Curso', 'Turno']

function rowsToMatrix(rows) {
  return rows.map(r => [r.Día, r.Horario, r.Asignatura, r.Curso, r.Turno])
}

/**
 * @param {Array<{ Día: string, Horario: string, Asignatura: string, Curso: string, Turno: string }>} rows
 */
export async function exportTeacherSchedulePdf(teacherName, rows) {
  const [{ jsPDF }, { autoTable }] = await Promise.all([
    import('jspdf'),
    import('jspdf-autotable'),
  ])

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  })

  const pageWidth = doc.internal.pageSize.getWidth()
  const margin = 15

  doc.setFontSize(16)
  doc.setFont(undefined, 'bold')
  doc.text('Horario de Clases', pageWidth / 2, 18, { align: 'center' })

  doc.setFontSize(12)
  doc.setFont(undefined, 'normal')
  doc.text(teacherName, pageWidth / 2, 26, { align: 'center' })

  autoTable(doc, {
    head: [COLUMNS],
    body: rowsToMatrix(rows),
    startY: 32,
    styles: { fontSize: 9, cellPadding: 2, overflow: 'linebreak' },
    headStyles: { fillColor: [49, 46, 129], halign: 'center' },
    columnStyles: {
      0: { cellWidth: 28 },
      1: { cellWidth: 28 },
      2: { cellWidth: 48 },
      3: { cellWidth: 38 },
      4: { cellWidth: 28 },
    },
    margin: { top: 32, left: margin, right: margin, bottom: 15 },
    tableWidth: pageWidth - margin * 2,
    showHead: 'everyPage',
  })

  const pageCount = doc.internal.getNumberOfPages()
  const pageHeight = doc.internal.pageSize.getHeight()
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.setFontSize(8)
    doc.setTextColor(120)
    doc.text(`Página ${i} de ${pageCount}`, pageWidth / 2, pageHeight - 8, {
      align: 'center',
    })
  }

  doc.save(`horario_${safeFilename(teacherName)}.pdf`)
}

/**
 * @param {Array<{ Día: string, Horario: string, Asignatura: string, Curso: string, Turno: string }>} rows
 */
export async function exportTeacherScheduleXls(teacherName, rows) {
  const XLSX = await import('xlsx')

  const sheetData = [
    ['Horario de Clases'],
    [teacherName],
    [],
    COLUMNS,
    ...rowsToMatrix(rows),
  ]

  const sheet = XLSX.utils.aoa_to_sheet(sheetData)

  sheet['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
  ]

  sheet['!cols'] = [
    { wch: 14 },
    { wch: 14 },
    { wch: 28 },
    { wch: 22 },
    { wch: 14 },
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, 'Horario')
  XLSX.writeFile(workbook, `horario_${safeFilename(teacherName)}.xlsx`)
}
